<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header card-gis-filter" v-if="isIndex()">
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="1">
            <div class="row">
              <div class="col-md-auto">
                <label>Pluviómetro *</label>
                <br />
                <el-select
                  placeholder="Selecionar..."
                  id="listRainAccumulators"
                  style="width: 100%"
                  class="select-primary mb-3 shadow-sm"
                  v-model="model.rainAccumulators"
                  filterable
                  clearable
                  multiple
                  collapse-tags
                  @change="
                    selectAllFromSelect(
                      'model.rainAccumulators',
                      listRainAccumulators
                    )
                  "
                >
                  <el-option
                    v-for="option in this.concatAll(listRainAccumulators)"
                    class="select-primary selected-all"
                    :value="option.id"
                    :label="option.name"
                    :key="option.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-md-auto">
                <label>Intensidad de Lluvia *</label>
                <br />
                <el-select
                  placeholder="Selecionar..."
                  id="listRainIntensity"
                  style="width: 100%"
                  class="select-primary mb-3 shadow-sm"
                  v-model="model.rainIntensity"
                  filterable
                  clearable
                  multiple
                  collapse-tags
                  @change="
                    selectAllFromSelect(
                      'model.rainIntensity',
                      listRainIntensity
                    )
                  "
                >
                  <el-option
                    v-for="option in this.concatAll(listRainIntensity)"
                    class="select-primary selected-all"
                    :value="option.id"
                    :label="option.name"
                    :key="option.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-md-auto">
                <label>{{ $t('common_words.analyze_by') }} </label>
                <br />
                <el-select
                  @change="changeByInterval"
                  filterable
                  @clear="model.bySel = null"
                  class="select-primary custom-width-select required-year shadow-sm"
                  size="large"
                  v-model="model.bySel"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="option in Object.values(optionsInterval)"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-12 col-sm-8 col-md-4 col-lg-4 col-xl-3"
                v-if="model.bySel != 'week' && model.bySel != 'year'"
              >
                <label>{{ $t('common_words.calendar') }}</label>
                <br />
                <el-date-picker
                  v-if="renderComponent"
                  v-model="model.rangeDate"
                  class="shadow-sm required-year"
                  v-bind:type="typedatepicket"
                  :picker-options="pickerOptions"
                  range-separator="-"
                  :placeholder="`${$t('common_words.select2')}...`"
                  :start-placeholder="$t('common_words.initial_date')"
                  :end-placeholder="$t('common_words.final_date')"
                >
                </el-date-picker>
              </div>
              <div
                class="col-md-auto"
                v-if="model.bySel == 'week' || model.bySel == 'year'"
              >
                <label>Año Inicial </label>
                <br />
                <el-select
                  id="year_sel_init"
                  filterable
                  class="select-primary custom-width-select required-year shadow-sm"
                  size="large"
                  v-model="model.year_sel_init"
                >
                  <el-option
                    v-for="(option, index) in Object.keys(listYears).reverse()"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-md-auto" v-if="model.bySel == 'week'">
                <label>Semana Inicial </label>
                <br />
                <el-select
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="model.week_sel_init"
                >
                  <el-option
                    v-for="(week, index) in listYears[model.year_sel_init]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-md-auto"
                v-if="model.bySel == 'week' || model.bySel == 'year'"
              >
                <label>Año Final </label>
                <br />
                <el-select
                  id="year_sel_end"
                  filterable
                  class="select-primary custom-width-select required-year shadow-sm"
                  size="large"
                  v-model="model.year_sel_end"
                >
                  <el-option
                    v-for="(option, index) in Object.keys(listYears).reverse()"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-md-auto" v-if="model.bySel == 'week'">
                <label>Semana Final </label>
                <br />
                <el-select
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="model.week_sel_end"
                >
                  <el-option
                    v-for="(week, index) in listYears[model.year_sel_end]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-md-4 col-xl-2">
                <label class="label-primary" style="color: transparent">{{
                  $t('common_words.filter')
                }}</label
                ><br />
                <l-button wide type="info" class="btn-filter" @click="validate">
                  {{ $t('common_words.filter') }}
                </l-button>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </card>
    </div>
  </div>
</template>
<script>
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinDatePicker from 'src/util/mixinDatePicker';
import MixinPermissions from 'src/util/mixinPermissions';
import { Axios } from 'src/class/Axios.js';
import store from '@/store';

export default {
  mixins: [mixinMasters, MixinPermissions, MixinMenu, MixinDatePicker],
  data() {
    return {
      model: {
        bySel: 'week',
        year_sel_init: null,
        week_sel_init: 1,
        year_sel_end: null,
        week_sel_end: 1,
        rainAccumulators: [],
        rainIntensity: [1, 2, 3, 4],
        rangeDate: [
          new Date(new Date().getFullYear(), new Date().getMonth(), 1),
          new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
        ],
      },
      activeName: '1',
      avancedReport: false,
      typedatepicket: 'daterange',
      listRainAccumulators: [],
      listYears: [],
      listRainIntensity: [
        { id: 1, name: 'Lluvia Nula o Muy Leve' },
        { id: 2, name: 'Lluvia Leve' },
        { id: 3, name: 'Lluvia Moderada' },
        { id: 4, name: 'Lluvia Intensa' },
      ],
    };
  },
  computed: {
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }
      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    optionsInterval() {
      return {
        0: { label: this.$i18n.t('common_words.day'), value: 'daterange' },
        1: { label: this.$i18n.t('common_words.week'), value: 'week' },
        2: { label: this.$i18n.t('common_words.month'), value: 'monthrange' },
        3: { label: this.$i18n.t('common_words.year'), value: 'year' },
      };
    },
    getLabelInterval() {
      try {
        return Object.values(this.optionsInterval).find(
          (option) => option.value === this.model.bySel
        ).label;
      } catch (error) {
        return this.$i18n.t('common_words.interval');
      }
    },
  },
  methods: {
    handleCollapse(val) {
      this.valueCollapse = val;
    },
    changeByInterval() {
      this.avancedReport = false;
      this.typedatepicket = this.model.bySel;
    },
    async validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (this.model.rainAccumulators.length == 0) {
          let sel = document.getElementById('listRainAccumulators');
          sel.focus();
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
          return false;
        }
        if (this.model.rainIntensity.length == 0) {
          let sel = document.getElementById('listRainIntensity');
          sel.focus();
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
          return false;
        }
        if (!this.model.year_sel_init) {
          let sel = document.getElementById('year_sel_init');
          sel.focus();
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
          return false;
        }
        if (!this.model.year_sel_end) {
          let sel = document.getElementById('year_sel_end');
          sel.focus();
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
          return false;
        }
        if (isValid) this.getData();
      });
    },
    getData() {
      this.showHideLoading(true);
      let param = {
        route: 'devices/reportrainaccumulators/getreportinfo',
        model: this.model,
      };
      Axios.postMasters(param)
        .then((response) => {
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    },
  },
  created() {
    this.showHideLoading(true);
    Axios.getMasters('devices/reportrainaccumulators/getselectinfo')
      .then((response) => {
        let responseData = response.data;
        this.listYears = responseData.listYears;
        this.model.year_sel_init = Object.keys(this.listYears).reverse()[0];
        this.model.year_sel_end = Object.keys(this.listYears).reverse()[0];
        this.listRainAccumulators = responseData.listRainAccumulators;
        if (this.listRainAccumulators.length > 0)
          this.model.rainAccumulators = responseData.listRainAccumulatorIds;
        this.showHideLoading();
      })
      .catch((error) => {
        this.showHideLoading();
        this.showMessageErrors(error);
      });
  },
  mounted() {
    this.selectedItemOnMenu('devices');
  },
  destroyed() {
    this.deselectedItemOnMenu('devices');
  },
};
</script>